<template>
  <div id="webcams_container">
    <div class="list_webcam" v-if="list_webcams.length > 0">
      <h3 class="align_left">
        <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
        Webcams
      </h3>
      <b-row>
        <b-col
          md="6"
          v-for="(webcam, index_webcam) in list_webcams"
          :key="index_webcam"
        >
          <h4>{{webcam.titre}}</h4>
          <iframe width="100%" height="315" :src="webcam.lien" :title="webcam.titre" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </b-col>
      </b-row>
    </div>
    <div class="sep"></div>
    <div class="list_videos" v-if="list_videos.length > 0">
      <h3 class="align_left">
        <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
        Videos
      </h3>
      <b-row>
        <b-col
          md="6"
          v-for="(video, index_videos) in list_videos"
          :key="index_videos"
        >
          <h4>{{video.titre}}</h4>
          <iframe width="100%" height="315" :src="video.lien" :title="video.titre" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        
        </b-col>
      </b-row>
    </div>
    <transition name="fade">
      <div v-if="webcams.length === 0 && !$store.state.loading">
        <h3>{{ $t("tab_live.erreur_webcam") }}</h3>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      webcams: [],
    };
  },
  computed: {
    list_webcams() {
      var filtered = this.webcams;
      filtered = filtered.filter((item) => item.type === "webcam");
      return filtered;
    },
    list_videos() {
      var filtered = this.webcams;
      filtered = filtered.filter((item) => item.type === "video");
      return filtered;
    },
  },
  methods: {
    fetchWebcams() {
      var _this = this;
      axios
        .get(
          this.$store.state.base_url +
            "/live/webcams/get.php?id=" +
            this.$store.state.module.id
        )
        .then(function (response) {
          _this.$store.commit("unsetLoading");
          console.log("LIVE -- Fetch webcams ");
          if (response.data !== "") {
            _this.webcams = response.data;
          }
        });
    },
  },
  created() {
    this.fetchWebcams();
  },
};
</script>

<style lang="scss" scoped>
</style>